/**
 * Форматирует число в рубли с использованием Intl.NumberFormat
 * @param amount - сумма в рублях
 * @returns отформатированная строка с символом рубля
 */
export const formatRubles = (
  amount: number | undefined,
  options?: Intl.NumberFormatOptions,
): string => {
  const formatter = new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    ...options,
  });

  return formatter.format(amount || 0);
};
